import { render } from "./AddOwnershipAddress.vue?vue&type=template&id=6db0415e&scoped=true"
import script from "./AddOwnershipAddress.vue?vue&type=script&lang=js"
export * from "./AddOwnershipAddress.vue?vue&type=script&lang=js"

import "./AddOwnershipAddress.vue?vue&type=style&index=0&id=6db0415e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db0415e"]])

export default __exports__